/**
 * Base URL das Edge Functions.
 *
 * Por padrão usa o mesmo projeto do supabase-js (`VITE_SUPABASE_URL`), ou seja,
 * as functions DEPLOYADAS no Supabase. Para exercitar functions rodando
 * localmente (`pnpm functions:serve`) a partir da app, defina
 * `VITE_FUNCTIONS_URL` (ex.: http://localhost:54321) no `.env.local` — auth e
 * leituras/escritas de banco continuam batendo no projeto REMOTO via
 * supabase-js; só as chamadas de function passam a apontar pro local.
 */
const RAW =
  (import.meta.env.VITE_FUNCTIONS_URL as string | undefined) ||
  (import.meta.env.VITE_SUPABASE_URL as string | undefined) ||
  '';

export const FUNCTIONS_URL = RAW.replace(/\/$/, '');

/** Monta a URL completa de uma Edge Function. `name` com ou sem barra inicial. */
export function functionUrl(name: string): string {
  const suffix = name.startsWith('/') ? name : `/${name}`;
  return `${FUNCTIONS_URL}/functions/v1${suffix}`;
}
